module.exports = __webpack_public_path__ + "img/call-centre-and-global-stars-visual.c22561ea.png";